import MarketingHelper from "../checkout/helpers/marketing/marketingHelper";

const configClientSeenVariants = new Set();

export function setupHooks(measurementId) {
  return (hooks) => hooks.on('flagEvaluated', evaluationDetails => {
    if (!measurementId) {
      return;
    }
    const variant = "configcat-" + evaluationDetails.key + "-" + evaluationDetails.value;
    const variantKey = `${variant}:${evaluationDetails.variationId}:${measurementId}`;
    if (configClientSeenVariants.has(variantKey)) {
      return;
    }
    const helper = new MarketingHelper();
    helper.sendEvent(helper.SERVICE_GOOGLE, 'experience_impression', {
      'exp_variant_string': variant,
      'variation_id': evaluationDetails.variationId
    }, measurementId);

    configClientSeenVariants.add(variantKey);
  });
}
